import React from 'react';
import RoundState from '../../../../_types/RoundState';
import {
  RulesAndRewardsContainer,
  SectionTitle,
} from '../../../../GameFormComponents';
import RewardType from '../../../../_types/RewardType';
import ItemSelectInput from '../../../../custom-inputs/ItemSelectInput';
import IfPlacedInputs from './round-rewards-inputs/IfPlacedInputs';
import HitQuotaAndPlacedInputs from './round-rewards-inputs/HitQuotaAndPlacedInputs';
import CompanyActionInputs from './round-rewards-inputs/CompanyActionInputs';
import NewGameState from '../../../../_types/NewGameState';

interface Props {
  onChangeRoundState: (roundState: RoundState) => void;
  roundState: RoundState;
  rewards: RewardType[];
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
  tabNo: number;
}

const RoundRewardsView: React.FC<Props> = ({
  onChangeRoundState,
  rewards,
  roundState,
  newGameState,
  onChangeNewGameState,
  tabNo,
}) => {
  return (
    <RulesAndRewardsContainer>
      <SectionTitle>Rewards</SectionTitle>

      <ItemSelectInput
        label="Reward Type"
        selectedItem={roundState.rewardCurrency}
        onSelect={(newSelectedItem: { label: string; value: any } | null) => {
          if (!newSelectedItem) return;
          const rewardCurrency = newSelectedItem.value;
          const rewardType = `${roundState.rewardWhen}_${rewardCurrency}`;

          onChangeRoundState({
            ...roundState,
            rewardCurrency,
            rewardType,
          });

          const newGameStateCopy = { ...newGameState };
          if (newGameStateCopy.bracket.roundValues[tabNo - 1]) {
            newGameStateCopy.bracket.roundValues[tabNo - 1].rewardCurrency =
              rewardCurrency;
            newGameStateCopy.bracket.roundValues[tabNo - 1].rewardType =
              rewardType;
          } else {
            newGameStateCopy.bracket.roundValues.push({
              ...roundState,
              rewardCurrency,
              rewardType,
            });
          }
          onChangeNewGameState(newGameStateCopy);
        }}
        items={[
          { label: 'Reward store item', value: 'reward', icon: 'shoppingBag' },
          { label: 'Coins', value: 'points', icon: 'coins' },
        ]}
        numColumns={2}
      />
      {/* <ItemSelectInput
        label="Rules"
        selectedItem={roundState.rewardWhen}
        onSelect={(newSelectedItem: { label: string; value: any } | null) => {
          if (!newSelectedItem) return;
          const rewardWhen = newSelectedItem.value;
          const rewardType = `${rewardWhen}_${roundState.rewardCurrency}`;

          onChangeRoundState({
            ...roundState,
            rewardWhen,
            rewardType,
          });

          const newGameStateCopy = { ...newGameState };
          if (newGameStateCopy.bracket.roundValues[tabNo - 1]) {
            newGameStateCopy.bracket.roundValues[tabNo - 1].rewardWhen =
              rewardWhen;
            newGameStateCopy.bracket.roundValues[tabNo - 1].rewardType =
              rewardType;
          } else {
            newGameStateCopy.bracket.roundValues.push({
              ...roundState,
              rewardWhen,
              rewardType,
            });
          }
          onChangeNewGameState(newGameStateCopy);
        }}
        items={[
          {
            label: 'If placed (ex 1st,2nd)',
            value: 'mission',
            icon: 'medal',
          },
          {
            label: 'Hit Quota and Placed',
            value: 'mission_min',
            icon: 'flag',
          },

          {
            label: 'If Company Personal is met',
            value: 'goal',
            icon: 'flag',
          },
          {
            label: 'For every action (ex. $1/dial)',
            value: 'action',
            icon: 'repeat',
          },
        ]}
        numColumns={2}
      /> */}
      <IfPlacedInputs
        rewards={rewards}
        roundState={roundState}
        onChangeRoundState={onChangeRoundState}
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
        tabNo={tabNo}
      />
      <HitQuotaAndPlacedInputs
        rewards={rewards}
        roundState={roundState}
        onChangeRoundState={onChangeRoundState}
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
        tabNo={tabNo}
      />
      <CompanyActionInputs
        rewards={rewards}
        roundState={roundState}
        onChangeRoundState={onChangeRoundState}
        newGameState={newGameState}
        onChangeNewGameState={onChangeNewGameState}
        tabNo={tabNo}
      />
    </RulesAndRewardsContainer>
  );
};

export default RoundRewardsView;
